import {
  getFabricCareIconClassName,
  getFabricCareIconMeta,
  getFabricCareIconSrc,
  type FabricCharacteristicsProfile,
} from '@utils/budget/fabricCharacteristics'
import { ui } from '@utils/i18n/uiCopy'

export function FabricCharacteristicsBlock({
  profile,
}: {
  profile: FabricCharacteristicsProfile
}) {
  return (
    <div
      data-fabric-care-block
      className='mt-3'
    >
      <p className='font-bold text-[#2A2A2A]'>{ui('fabricCharacteristics')}</p>
      <p className='mt-1 font-bold leading-snug text-[#2A2A2A]'>{profile.title}</p>
      <p className='leading-relaxed text-[#2A2A2A]'>{profile.description}</p>
      <div className='mt-2 flex flex-wrap items-center gap-2'>
        {profile.icons.map((iconId) => {
          const { alt } = getFabricCareIconMeta(iconId)
          return (
            <img
              key={iconId}
              src={getFabricCareIconSrc(iconId)}
              alt={alt}
              title={alt}
              className={`${getFabricCareIconClassName(iconId)} object-contain`}
            />
          )
        })}
      </div>
    </div>
  )
}
